import React from "react";

import { Grid, Typography } from "@material-ui/core";

import Page from "components/admin/Page";

import AuditLogsTable from "./AuditLogsTable";

import { selectUserInfo } from "modules/auth/authSlice";
import { useAppSelector } from "store";

const AuditLogs: React.FC = () => {
    const userInfo = useAppSelector(selectUserInfo);

    return (
        <Page dataCy="pages-admin-audit">
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <br />
                    <Typography variant="subtitle1" component="div" color="textSecondary">
                        KPMG Admin - {userInfo.firstName} {userInfo.lastName}
                    </Typography>
                    <Typography variant="h3" component="div">
                        Audit
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12}>
                            <AuditLogsTable />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Page>
    );
};

export default AuditLogs;
